/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaCittadinoListItemDTO } from './pratica-cittadino-list-item-dto';
import { PraticaCittadinoOtpContextDTO } from './pratica-cittadino-otp-context-dto';
import { PraticaCittadinoEsitoGraduatoriaDTO } from './pratica-cittadino-esito-graduatoria-dto';
import { PraticaCittadinoCapabilitiesDTO } from './pratica-cittadino-capabilities-dto';


export interface PraticaCittadinoDetailDTO { 
    summary?: PraticaCittadinoListItemDTO;
    form_data?: { [key: string]: any; };
    capabilities?: PraticaCittadinoCapabilitiesDTO;
    otp_context?: PraticaCittadinoOtpContextDTO;
    esito_graduatoria?: PraticaCittadinoEsitoGraduatoriaDTO;
}

